export default __webpack_public_path__ + "images/2L.f0b2a76.png";